import type { ReactNode } from 'react';

interface HoverTooltipProps {
  text: string;
  children: ReactNode;
  className?: string;
}

export default function HoverTooltip({ text, children, className = '' }: HoverTooltipProps) {
  return (
    <span className={`group/tt relative inline-flex ${className}`}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 hidden w-max max-w-[18rem] -translate-x-1/2 rounded-md border border-slate-200 bg-slate-900 px-2 py-1 text-xs font-medium text-white shadow-xl group-hover/tt:block group-focus-within/tt:block dark:border-slate-700"
      >
        {text}
      </span>
    </span>
  );
}
